// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d3ea639b","732":"4cb05d19","977":"33a62544"}[chunkId] + ".chunk.js";
};